<template>
    <AutoComplete
        :key="`select_lang_${id}`"
        v-model="selectedLanguage"
        :suggestions="suggestions"
        option-label="name"
        :min-length="2"
        scroll-height="40vh"
        :auto-option-focus="false"
        :empty-search-message="t('profile.creation.completion.wizard.languages.notfound')"
        :invalid="invalid"
        @option-select="selectLang"
        @clear="clear"
        @complete="handleSearch"
    >
        <template #option="slotProps">
            {{ slotProps.option.name }}
        </template>
    </AutoComplete>
</template>

<script setup lang="ts">
    import {onMounted, ref, watch} from 'vue';
    import AutoComplete, {type AutoCompleteCompleteEvent, type AutoCompleteOptionSelectEvent} from 'primevue/autocomplete';
    import {useTranslation} from '#imports';
    import LanguageSearcher from '~/components/edit/languages/LanguageSearcher';

    const {t} = useTranslation();
    const searcher = new LanguageSearcher();
    const suggestions = ref(searcher.searchableLanguages);

    onMounted(async () => {
        await searcher.loadLanguages();
    });

    type SelectLanguageProps = {
        language: string;
        id: number;
        invalid?: boolean;
    };
    const props = withDefaults(defineProps<SelectLanguageProps>(), {
        invalid: false,
    });

    export type LanguageUpdated = {
        name: string;
        code: string;
        id: number;
    };
    const emits = defineEmits<{
        (e: 'languageUpdated', value: LanguageUpdated): void;
    }>();

    const selectedLanguage = ref(props.language);

    watch(
        () => props.language,
        (newLanguage) => (selectedLanguage.value = newLanguage),
    );

    function handleSearch(event: AutoCompleteCompleteEvent) {
        suggestions.value = searcher.search(event.query);
    }

    function selectLang(event: AutoCompleteOptionSelectEvent) {
        emits('languageUpdated', {name: event.value.name, code: event.value.code, id: props.id});
    }

    function clear() {
        emits('languageUpdated', {name: '', code: '', id: props.id});
    }
</script>
<style lang="scss">
    @import 'primeicons/primeicons.css';
</style>
